import aryan from "../Assets/Departments/Programming/Aryan.jpeg";
import om from "../Assets/Departments/Programming/om.jpeg";
import bhushan from "../Assets/Departments/Programming/Bhushan.jpeg";
import palash from "../Assets/Departments/Programming/Palash.jpg";
import prince from "../Assets/Departments/Programming/Princeton.jpeg";
import sarthak from "../Assets/Sarthakp.jpeg";
import anubahv from "../Assets/anubhav.jpg";
import akansha from "../Assets/Akansha.jpg";

export const creatorsData = [
  {
    name: "Aryan Jangid",
    position: " AI & DS ",
    linkedin: "https://www.linkedin.com/in/aryan-jangid-9641a2207/",
    instagram: "https://www.instagram.com/aj_aryan0007/",
    github: "https://github.com/aryanjangid",
    img: aryan,
  },
  {
    name: "Om Gawande",
    position: " CSE ",
    linkedin: "https://www.linkedin.com/in/om-gawande/",
    instagram: "https://www.instagram.com/_s_p_i_d_e_r_9480/",
    github: "https://github.com/Spyware007",
    img: om,
  },
  {
    name: "Palash Rambhia",
    position: " IT ",
    linkedin: "https://www.linkedin.com/in/palash-rambhia-bb5b66214/",
    instagram: "https://www.instagram.com/palash_2911/",
    github: "https://github.com/Palash2911",
    img: palash,
  },
  {
    name: "Bhushan Kale",
    position: " CSE ",
    linkedin: "https://www.linkedin.com/in/bhushan-kale-53493b203/",
    instagram: "https://www.instagram.com/bk_bhushan__/",
    github: "https://github.com/Bhushan8177",
    img: bhushan,
  },
  {
    name: "Princeton D'souza",
    position: " CSE ",
    linkedin: "https://www.linkedin.com/in/princeton-dsouza/",
    instagram: "https://www.instagram.com/princeton2102/",
    github: "https://github.com/Princeton21",
    img: prince,
  },
  {
    name: "Akanksha Jadhav",
    position: " CSE ",
    linkedin: "https://www.linkedin.com/in/akanksha-jadhav-81846421a/",
    instagram: "https://www.instagram.com/akanksha_jadhav__/",
    github: "https://github.com/Enthusiast22",
    img: akansha,
  },
  {
    name: "Sarthak Pawar",
    position: " CSE ",
    linkedin: "https://www.linkedin.com/in/sarthak-pawar-b679481a9/",
    instagram: "",
    github: "https://github.com/Grumppie",
    img: sarthak,
  },
  {
    name: "Anubhav Prabhkar",
    position: " CSE ",
    linkedin: "https://www.linkedin.com/in/anubhav-prabhakar-4395001a0/",
    instagram: "https://www.instagram.com/thisanubhav/",
    github: "https://github.com/anubhavprabhakar",
    img: anubahv,
  },
];
